import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      border: `1px solid ${theme.border}`,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    icon: {
      marginLeft: spacing.xxs,
      marginTop: 2,
    },
    left: {
      flexGrow: 1,
    },
    text: {
      color: theme.text.secondary,
    },
  };

  return styles;
};
